import { client, errorValidation } from "./service";

export const getCustomerList = async function ({
    phoneNumber
}) {
    try {
        let response = await client.get(`/customer/list?phoneNumber=${phoneNumber}`);
        console.log('here response', response)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}